import React from 'react';

function Terms() {
  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4">Terms and Conditions</h2>
      <p>
        By creating an account you agree to comply with our Terms and Conditions.
        These may be updated from time to time. Please review them regularly.
      </p>
    </div>
  );
}

export default Terms;